import { h } from "preact";
import { DayModel, dayNames, monthNames, range, WeekModel } from "./common";
import { useCurrentDay } from "hooks";

interface MultiDayCalendarProps {
    days: DayModel[];
    onDaySelected?: (date: Date) => void;
}

interface SingleWeekCalendarProps {
    week: WeekModel;
    onDaySelected?: (date: Date) => void;
}

export function SingleWeekCalendar(props: SingleWeekCalendarProps) {

    // todo: setting for if the sunday is on the left or right side
    
    return (
        <MultiDayCalendar days={props.week.days} onDaySelected={props.onDaySelected} />
    );
}

export function MultiDayCalendar(props: MultiDayCalendarProps) {
    return (
        <div class="calendar calendar-multiday">
            {
                props.days.map((day, index) => <DayColumn day={day} showHour={index == 0} onDaySelected={props.onDaySelected} />)
            }
        </div>
    );
}

function DayColumn(props: { day: DayModel, showHour: boolean, onDaySelected?: (date: Date) => void }) {
    const date = props.day.date;
    const weekDay = date.getDay();
    const today = useCurrentDay();
    const isCurrentMonth = today.year === date.getFullYear() && today.month === date.getMonth();
    let isToday = isCurrentMonth && today.day === (date.getDate());

    const name = dayNames[date.getDay()] + " " + (date.getDate());// + " " + monthNames[date.getMonth()] + " " + date.getFullYear();

    return (
        <div class={"calendar-day" + (isToday ? " today" : "") + (weekDay == 0 ? " sunday" : weekDay == 6 ? " saturday" : "")}>
            <a class="header" onClick={() => { props.onDaySelected && props.onDaySelected(props.day.date); }}>
                {name}
            </a>
            {
                range(24).map(hour => {
                    return (
                        <div>
                            {
                                props.showHour && <div class="hour">{hour}</div>
                            }
                            <div></div>
                        </div>
                    );
                })
            }
        </div>
    );
}
